/**
 *
 * Define shapes for the api to consume
 * You can also use GetInferredFromRaw to get the TS type from the shape
 *
 */

import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'
import { baseModelShape } from '../base-model'

/**
 * A single membership entry returned in the user payload.
 * Contains the org identity, the user's role name, and a flat list of
 * permission codenames granted by that role (e.g. "expenses.access").
 */
export const membershipShape = {
  organizationId: z.string().uuid(),
  organizationName: z.string(),
  roleName: z.string(),
  permissions: z.array(z.string()),
}

export type Membership = GetInferredFromRaw<typeof membershipShape>

export const userShape = {
  ...baseModelShape,
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  googleToken: z.record(z.string(), z.any()).nullable().optional(),
  phoneNumber: z.string().nullable().optional(),
  memberships: z.array(z.object(membershipShape)).optional().default([]),
  defaultOrganization: z.uuid().nullable().optional(),
}
export const userShapeWithToken = {
  ...userShape,
  token: z.string().readonly(),
}
export type User = GetInferredFromRaw<typeof userShape>
export type UserWithToken = GetInferredFromRaw<typeof userShapeWithToken>
export const userCreateShape = {
  email: userShape.email,
  firstName: userShape.firstName,
  lastName: userShape.lastName,
  password: z.string(),
  termsVersion: z.string(),
  privacyVersion: z.string(),
}
export const forgotPasswordShape = {
  email: z.string().email(),
}

export type ForgotPassword = GetInferredFromRaw<typeof forgotPasswordShape>

export const loginShape = {
  email: z.string().email(),
  password: z.string(),
}

export type LoginShape = GetInferredFromRaw<typeof loginShape>

export const userUpdateShape = {
  id: z.string().uuid(),
  interests: z.array(z.string()),
}

export const organizationShape = {
  ...baseModelShape,
  name: z.string(),
  defaultCurrency: z.string(),
  country: z.string().nullable().optional(),
  isBeta: z.boolean().optional(),
}

export type OrganizationShape = GetInferredFromRaw<typeof organizationShape>
